import $ from 'jquery';

class SitemapController {
    constructor(elem) {
        this.sitemapID = elem.id;
        this.plusIcon = '<i class="fa fa-plus" aria-hidden="true"></i>';
        this.initSitemapAsAccordion();
    }

    initSitemapAsAccordion() {
        $(`#${this.sitemapID} ul li`).each(function () {
            if ($(this).find('ul').length > 0) {
                $(this).addClass('hasSubnav');
            }
        });
        $(`#${this.sitemapID} ul li.hasSubnav > a`).append(this.plusIcon);
        $(`#${this.sitemapID} ul li.hasSubnav >a >i`).click(function (e) {
            e.preventDefault();
            $(this).closest('.hasSubnav').toggleClass('active').find('>ul')
                .slideToggle(600);
            $(this).closest('.hasSubnav i').toggleClass('fa-minus');
            $(this).closest('.hasSubnav i').toggleClass('fa-plus');
        });
    }

    static init(sitemapElem) {
        new SitemapController(sitemapElem); // eslint-disable-line no-new
    }
}

window.SitemapController = SitemapController;
export default SitemapController;
